import { render, staticRenderFns } from "./DateIsWeekday.vue?vue&type=template&id=bede5994&scoped=true"
import script from "./DateIsWeekday.vue?vue&type=script&lang=js"
export * from "./DateIsWeekday.vue?vue&type=script&lang=js"
import style0 from "./DateIsWeekday.vue?vue&type=style&index=0&id=bede5994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bede5994",
  null
  
)

export default component.exports